export default function debounce(callback = () => {}, delay = 200) {
  let timeout

  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => callback?.(...args), delay)
  }
}
